var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c("div", { staticClass: "custom-title" }, [
        _c("div", { staticClass: "custom-block tip" }, [
          _c("p", { staticClass: "custom-block-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c(
            "span",
            {
              staticStyle: {
                "padding-left": "20px",
                color: "#dd6161",
                "font-weight": "bold",
              },
            },
            [_vm._v(_vm._s(_vm.lineName))]
          ),
        ]),
        _c(
          "div",
          { staticClass: "return-list" },
          [
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-back", size: "mini" },
                on: {
                  click: function ($event) {
                    return _vm.returnIndex(
                      "/product/transport/runningplan/runningplan-list"
                    )
                  },
                },
              },
              [_vm._v("\n        返回列表\n      ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "form-contain" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                size: "small",
                "label-width": "100px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "班次类型：" } },
                [
                  _c("avue-radio", {
                    attrs: { dic: [{ label: "固定班次", value: 1 }] },
                    model: {
                      value: _vm.form.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "type", $$v)
                      },
                      expression: "form.type",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "生效日期：" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("avue-date", {
                      attrs: {
                        type: "daterange",
                        format: "yyyy-MM-dd",
                        valueFormat: "yyyy-MM-dd",
                        "picker-options": _vm.pickerOptions,
                      },
                      on: { change: _vm.handleChangeTimes },
                      model: {
                        value: _vm.times,
                        callback: function ($$v) {
                          _vm.times = $$v
                        },
                        expression: "times",
                      },
                    }),
                    _c("div", { staticClass: "tipsBox" }, [
                      _c("img", {
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: { src: require("./static/tips.png") },
                      }),
                      _c("span", [
                        _vm._v("点击某一天两下代表只选择那一天排班！"),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "fs" }, [
                    _vm._v("注意：排班时间跨度最长为30天"),
                  ]),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "供应商：" } },
                [
                  _c("avue-select", {
                    staticStyle: { width: "15vw" },
                    attrs: {
                      dic: _vm.merchantSelectData,
                      props: { label: "merchantName", value: "id" },
                      placeholder: "试试搜索:请选择供应商",
                      filterable: "",
                    },
                    on: { change: _vm.handleMerchSelect },
                    model: {
                      value: _vm.form.merchantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "merchantId", $$v)
                      },
                      expression: "form.merchantId",
                    },
                  }),
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "fs" }, [
                      _vm._v("*注意：请选择服务的供应商再添加班次"),
                    ]),
                  ]),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "设置排班：" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "flex-flow": "row",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          loading: _vm.isMerchSelect,
                          disabled: !_vm.form.merchantId,
                        },
                        on: { click: _vm.handleAddRow },
                      },
                      [_vm._v("\n            单个班次添加\n          ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          loading: _vm.isMerchSelect,
                          disabled: !_vm.form.merchantId,
                        },
                        on: { click: _vm.handleBatchPlantime },
                      },
                      [_vm._v("\n            按时间批量添加班次\n          ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          loading: _vm.isMerchSelect,
                          disabled: !_vm.form.merchantId,
                        },
                        on: { click: _vm.handleBatchDriverPlan },
                      },
                      [_vm._v("\n            按司机批量添加班次\n          ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.runningPlanTimeList,
                          border: "",
                          "column-key": "uuid",
                          "highlight-current-row": "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "序号",
                            type: "index",
                            width: "50",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "时间",
                            width: "210",
                            align: "center",
                            prop: "departureTime",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  !scope.row.timeRangeShow
                                    ? _c("span", [
                                        !scope.row.isnew
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.departureTime)
                                              ),
                                            ])
                                          : _c(
                                              "span",
                                              [
                                                _c("el-time-picker", {
                                                  attrs: {
                                                    "picker-options": {
                                                      selectableRange:
                                                        "00:00:01 - 23:59:59",
                                                    },
                                                    "value-format": "HH:mm",
                                                    format: "HH:mm",
                                                  },
                                                  model: {
                                                    value:
                                                      scope.row.departureTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "departureTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.departureTime",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                      ])
                                    : _c("el-time-picker", {
                                        staticStyle: { width: "180px" },
                                        attrs: {
                                          "is-range": "",
                                          "range-separator": "至",
                                          "start-placeholder": "开始时间",
                                          "end-placeholder": "结束时间",
                                          placeholder: "选择时间范围",
                                          format: "HH:mm",
                                          "value-format": "timestamp",
                                          size: "mini",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.timeRangeChange(
                                              $event,
                                              scope.row
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.timeRange,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "timeRange",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.timeRange",
                                        },
                                      }),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "has-permi",
                                          rawName: "v-has-permi",
                                          value: [
                                            "transport_runningplan_range",
                                          ],
                                          expression:
                                            "['transport_runningplan_range']",
                                        },
                                      ],
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          scope.row.timeRangeShow =
                                            !scope.row.timeRangeShow
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            scope.row.timeRangeShow
                                              ? "返回"
                                              : "区间发班"
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "价格方案",
                            width: "400",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择价格方案" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.seleRowPrice(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row.priceMethodId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "priceMethodId",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.priceMethodId",
                                      },
                                    },
                                    _vm._l(_vm.priceMethodDic, function (item) {
                                      return _c("el-option", {
                                        key: item.carTypeId,
                                        attrs: {
                                          label: item.priceMethodName,
                                          value: item.priceMethodId,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  scope.row.priceMethodId !== ""
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handlePriceView(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  改价\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "司机车辆信息",
                            width: "220",
                            align: "center",
                            prop: "driverId",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.driverInfo)),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "p10" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleSetDriver(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    设置\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "站点配置",
                            width: "480",
                            align: "center",
                            prop: "stationConfigVos",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.stationNameGroup)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "标签",
                            width: "300",
                            align: "center",
                            prop: "labelCheck",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-popover",
                                    {
                                      key: scope.row.uuid,
                                      attrs: {
                                        "popper-class":
                                          "popbox-" + scope.row.uuid,
                                        placement: "bottom",
                                        width: "160",
                                        trigger: "manual",
                                      },
                                      model: {
                                        value: scope.row.labelVisible,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "labelVisible",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.labelVisible",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "loading",
                                              rawName: "v-loading",
                                              value: _vm.labelLoading,
                                              expression: "labelLoading",
                                            },
                                          ],
                                          staticStyle: {
                                            padding: "0px 0px 20px 20px",
                                            "max-height": "200px",
                                            "overflow-y": "scroll",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              attrs: { max: 2 },
                                              on: {
                                                change: _vm.labelCheckChange,
                                              },
                                              model: {
                                                value: scope.row.labelCheck,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "labelCheck",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.labelCheck",
                                              },
                                            },
                                            _vm._l(
                                              _vm.labelCheckList,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.label,
                                                    staticStyle: {
                                                      display: "flex",
                                                      "justify-content":
                                                        "space-between",
                                                      "align-items": "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-checkbox",
                                                      {
                                                        attrs: {
                                                          label: item.type,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "has-permi",
                                                            rawName:
                                                              "v-has-permi",
                                                            value: [
                                                              "edit_label",
                                                            ],
                                                            expression:
                                                              "['edit_label']",
                                                          },
                                                        ],
                                                        attrs: {
                                                          size: "mini",
                                                          type: "text",
                                                          icon: "el-icon-edit",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleAdd(
                                                              item,
                                                              "edit"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          编辑\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-justify-between",
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "has-permi",
                                                      rawName: "v-has-permi",
                                                      value: ["add_label"],
                                                      expression:
                                                        "['add_label']",
                                                    },
                                                  ],
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleAdd(
                                                        scope.row,
                                                        "add"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        添加\n                      "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "text",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addLabels(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        取消\n                      "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.submitLabel(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        确定\n                      "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "add-labels",
                                          attrs: {
                                            slot: "reference",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addLabels(
                                                scope.row,
                                                scope
                                              )
                                            },
                                          },
                                          slot: "reference",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    添加\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    _vm._l(
                                      scope.row.labelList,
                                      function (item) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: item.uuid,
                                            staticStyle: {
                                              "margin-right": "5px",
                                            },
                                            attrs: {
                                              closable: "",
                                              type: "warning",
                                              size: "small",
                                            },
                                            on: {
                                              close: function ($event) {
                                                return _vm.handleCloseLabel(
                                                  item.id,
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.labelCheckList.filter(
                                                    function (it) {
                                                      return +it.id === +item.id
                                                    }
                                                  )[0].name
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "置顶标签",
                            width: "300",
                            align: "center",
                            prop: "topLableIds",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change: function (val) {
                                          return _vm.handleLabelChange(
                                            val,
                                            scope.row
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row.topLableIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "topLableIds",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.topLableIds",
                                      },
                                    },
                                    _vm._l(
                                      scope.row.labelList,
                                      function (item) {
                                        return _c(
                                          "el-checkbox",
                                          { key: item, attrs: { label: item } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.labelCheckList.filter(
                                                    function (it) {
                                                      return +it.id === +item.id
                                                    }
                                                  )[0].name
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            align: "center",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeRow(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-flow": "row",
                "padding-bottom": "30px",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "small" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.plantimeShowDialog
        ? _c("batch-running-plan", {
            ref: "planAdd",
            attrs: { labelList: _vm.labelCheckList },
            on: {
              batchPlanTime: _vm.handlePlanTimeData,
              addLabelClose: _vm.getLabelList,
            },
          })
        : _vm._e(),
      _vm.driverPlanShowDialog
        ? _c("batch-driver-plan", {
            ref: "driverPlanAdd",
            attrs: { labelList: _vm.labelCheckList },
            on: {
              batchPlanTime: _vm.handlePlanTimeData,
              addLabelClose: _vm.getLabelList,
            },
          })
        : _vm._e(),
      _vm.setStationShowDialog
        ? _c("set-station", {
            ref: "setStation",
            on: { LineFormData: _vm.handlelinedata },
          })
        : _vm._e(),
      _vm.setDriverShowDialog
        ? _c("set-driver", {
            ref: "setDriver",
            on: { DriverFormData: _vm.handledriverdata },
          })
        : _vm._e(),
      _vm.showViewPriceDialog
        ? _c("price-view", {
            ref: "priceview",
            on: { revisePriceInfo: _vm.revisePriceInfo },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置价格方案",
            visible: _vm.setVisible,
            "append-to-body": true,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.setVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.info, size: "small", inline: true } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-row",
                    { staticStyle: { margin: "auto 0" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "10px" },
                          attrs: { span: 8 },
                        },
                        [
                          _c("avue-select", {
                            staticStyle: { width: "20vw" },
                            attrs: {
                              placeholder: "请选择价格方案",
                              dic: _vm.uniquePriceMethod(_vm.priceMthodItems),
                              disabled: _vm.pricemethodDisabled,
                              props: {
                                label: "priceMethodName",
                                value: "priceMethodId",
                              },
                            },
                            on: { change: _vm.handleSelectPrice },
                            model: {
                              value: _vm.info.priceMethodId,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "priceMethodId", $$v)
                              },
                              expression: "info.priceMethodId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: { click: _vm.setCancel },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.setSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddLabel", { ref: "addLabel", on: { close: _vm.getLabelList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }